import { memo } from 'react';
import { t } from 'i18next';
import { Stack } from '@mui/system';
import { Divider } from '@mui/material';

import { Accordion } from '@common/components/Accordion';
import { VehicleType } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/common/VehicleType';

import { LoadType } from '../singularStation/LoadType';
import { AreaDimensions } from '../AreaDimensions';
import { LoadHandlingType } from './LoadHandlingType';
import { StationSpecProperties } from './StationSpecProperties';

function ManualAreaParametersComponent() {
  return (
    <Stack spacing={1} divider={<Divider />}>
      <AreaDimensions />
      <Accordion
        title={t<string>('interface:properties.manual_area.title', 'Manual Area')}
        unmountOnExit
        defaultExpanded
        sx={{ px: 2 }}
      >
        <Stack direction='column' spacing={1}>
          <Accordion title='Vehicle settings' unmountOnExit defaultExpanded>
            <Stack direction='column' spacing={1} pb={2}>
              <VehicleType />
              <LoadType />
              <LoadHandlingType />
              <StationSpecProperties />
            </Stack>
          </Accordion>
        </Stack>
      </Accordion>
    </Stack>
  );
}

export const ManualAreaParameters = memo(ManualAreaParametersComponent);
